import { useEffect, useRef, useState } from 'react'

import { loadMercadoPago } from '@mercadopago/sdk-js'

import { useRechargeForm } from '../../hooks/useRechargeForm'
import { cardFormFields } from './constants'
import { handleScriptLoad } from './helpers'

let mpPromise: Promise<MercadoPagoInstance> | null = null

const MP_KEY = process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY

export const useMercadoPago: UseMercadoPago = ({ isActive, amount }) => {
  const [mp, setMp] = useState<MercadoPagoInstance | null>(null)
  const [error, setError] = useState<unknown | null>(null)

  const [isFormMounted, setIsFormMounted] = useState(false)

  const { setCardToken, handleChangeCardForm } = useRechargeForm()

  useEffect(() => {
    if (!isActive || !MP_KEY) return

    if (!mpPromise) {
      mpPromise = loadMercadoPago().then(() => {
        if (!window.MercadoPago) {
          throw new Error('MercadoPago SDK not available')
        }

        return new window.MercadoPago(MP_KEY)
      })
    }

    mpPromise.then(instance => setMp(instance)).catch(err => setError(err))
  }, [isActive])

  /**
   * Handle script load
   */
  useEffect(() => {
    if (!isActive) return

    handleScriptLoad()
  }, [isActive])

  /**
   * Handle form
   */

  const mpCardFormRef = useRef<CardFormInstance>(null)

  useEffect(() => {
    if (!mp || !isActive) return

    const cardForm = mp.cardForm({
      amount: amount.toString(),
      iframe: false,
      form: cardFormFields,
      callbacks: {
        onFormMounted: error => {
          setIsFormMounted(!error)
          if (error) {
            console.debug('Error on MP form mounted:', error)
          }
        },
        onSubmit: event => {
          event.preventDefault()

          const data = cardForm.getCardFormData()

          const brand = data.paymentMethodId

          handleChangeCardForm({
            isValid: true,
            brand
          })

          const { token } = cardForm.getCardFormData()

          if (!token) {
            console.error('Token não foi gerado pelo Mercado Pago')
            return
          }

          setCardToken(token)
        }
      }
    })

    mpCardFormRef.current = cardForm

    return () => {
      mpCardFormRef.current = null
      setIsFormMounted(false)
      cardForm?.unmount?.()
    }
  }, [mp, setCardToken, amount, isActive, handleChangeCardForm])

  return {
    mp,
    error,
    isFormMounted
  }
}
